export const time = {
  state: {
    init: {
      description:
        'В зависимости от времени получения звонка позволяет перенаправить его на нужный сервис. Удобно использовать для организации обработки звонков в рабочее и нерабочее время.'
    },
    add_schedule: {
      title: 'Выбрать расписание',
      title_edit: 'Изменить расписание',
      required: 'Расписание не выбрано'
    }
  }
};
